/**
 * Shared bets: turn bet-slip legs into the small display object a Community
 * message carries (`messageData.bet`, sanitized again server-side in
 * functions/communityAdmin.js), and hand it to the Community composer across
 * a navigation via sessionStorage.
 */
const KEY = 'bo_pending_share';

const num = (v) => (Number.isFinite(Number(v)) && v !== null && v !== '' ? Number(v) : null);

/** American odds from a leg's raw price fields, if present. */
function legOdds(raw = {}) {
    const am = num(raw.american_price ?? raw.americanOdds ?? raw.odds);
    if (am != null && Math.abs(am) >= 100) return Math.round(am);
    const dec = num(raw.price);
    if (dec != null && dec > 1) return dec >= 2 ? Math.round((dec - 1) * 100) : Math.round(-100 / (dec - 1));
    return null;
}

/** Parlay American odds from leg American odds (product of decimals). */
export function parlayAmerican(odds) {
    const decs = odds.map((o) => (o >= 100 ? 1 + o / 100 : 1 + 100 / Math.abs(o)));
    if (!decs.length || decs.some((d) => !Number.isFinite(d))) return null;
    const d = decs.reduce((a, b) => a * b, 1);
    return d >= 2 ? Math.round((d - 1) * 100) : Math.round(-100 / (d - 1));
}

export function buildSharedBetFromLegs(legs = [], { betMode, query } = {}) {
    const rows = legs.slice(0, 6).map((l) => ({ label: String(l.title || l.raw?.selection || l.description || 'Leg').slice(0, 140), odds: legOdds(l.raw || {}) }));
    if (!rows.length) return null;
    const single = rows.length === 1;
    const odds = rows.every((r) => r.odds != null) ? (single ? rows[0].odds : parlayAmerican(rows.map((r) => r.odds))) : null;
    const book = legs[0]?.raw?.sportsbook || null;
    return {
        kind: !single && betMode !== 'straight' ? 'sgp' : 'straight',
        title: single ? rows[0].label : `${rows.length}-leg ${betMode === 'straight' ? 'parlay' : 'same-game parlay'}`,
        odds,
        book: book ? String(book).slice(0, 60) : null,
        query: query ? String(query).slice(0, 200) : null,
        legs: single ? [] : rows,
    };
}

export function queuePendingShare(bet) {
    try { if (bet && typeof sessionStorage !== 'undefined') sessionStorage.setItem(KEY, JSON.stringify(bet)); } catch { /* private mode */ }
}

export function takePendingShare() {
    try {
        if (typeof sessionStorage === 'undefined') return null;
        const raw = sessionStorage.getItem(KEY);
        sessionStorage.removeItem(KEY);
        return raw ? JSON.parse(raw) : null;
    } catch { return null; }
}

export const formatAmerican = (o) => (o == null ? '' : o > 0 ? `+${o}` : String(o));
